import { Link, useParams } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOMeta from '@/components/feature/SEOMeta';
import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const categoryArticles = articles.filter((a) => a.category === slug);

  if (!category) {
    return (
      <>
        <Navbar />
        <div className="min-h-screen flex items-center justify-center pt-16">
          <p className="text-foreground-500">分类不存在</p>
        </div>
        <Footer />
      </>
    );
  }

  const mainArticle = categoryArticles[0];
  const gridArticles = categoryArticles.slice(1, 4);
  const listArticles = categoryArticles.slice(4);

  return (
    <>
      <SEOMeta
        title={`51黑料网${category.name} - 最新${category.name}吃瓜爆料 | 每日大赛在线观看`}
        description={`51黑料网${category.name}专区，${category.description}。实时更新最新${category.name}黑料，吃瓜群众不可错过的独家爆料平台。`}
        keywords={`51黑料网,${category.name},吃瓜,爆料,每日大赛,在线观看,黑料`}
        canonicalUrl={`https://51heiliaowang.com/category/${slug}`}
        jsonLd={[
          {
            '@context': 'https://schema.org',
            '@type': 'CollectionPage',
            name: `51黑料网${category.name}`,
            description: category.description,
            url: `https://51heiliaowang.com/category/${slug}`,
            isPartOf: { '@type': 'WebSite', name: '51黑料网', url: 'https://51heiliaowang.com' },
          },
          {
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              { '@type': 'ListItem', position: 1, name: '首页', item: 'https://51heiliaowang.com' },
              { '@type': 'ListItem', position: 2, name: category.name, item: `https://51heiliaowang.com/category/${slug}` },
            ],
          },
        ]}
      />

      <Navbar />

      <main>
        {/* Category Hero */}
        <section className="relative h-[450px] md:h-[550px] flex items-center overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Dark%20moody%20abstract%20gradient%20background%20with%20deep%20emerald%20green%20and%20charcoal%20black%2C%20mysterious%20cinematic%20noir%20texture%2C%20subtle%20atmospheric%20light%20beams%2C%20dark%20minimalist%20composition%2C%20editorial%20fine%20art%20quality%2C%20no%20text%2C%20no%20people&width=1920&height=900&seq=category-hero-generic&orientation=landscape"
              alt=""
              className="w-full h-full object-cover object-top"
              aria-hidden="true"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
          </div>

          <div className="relative z-10 w-full px-6 md:px-10">
            {/* Breadcrumb */}
            <nav className="mb-6" aria-label="面包屑导航">
              <ol className="flex items-center gap-2 text-sm text-white/50">
                <li><Link to="/" className="hover:text-white transition-colors cursor-pointer whitespace-nowrap">首页</Link></li>
                <li><i className="ri-arrow-right-s-line text-xs"></i></li>
                <li className="text-white font-medium whitespace-nowrap">{category.name}</li>
              </ol>
            </nav>

            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-500/20 border border-accent-500/30 mb-4">
              <i className={`${category.icon} text-accent-400 text-sm`}></i>
              <span className="text-xs font-medium text-accent-300 whitespace-nowrap">{category.description}</span>
            </div>

            <h1 className="text-4xl md:text-6xl lg:text-7xl font-black text-white leading-tight tracking-tight">
              {category.name}
              <br />
              <span className="text-accent-400">独家爆料专区</span>
            </h1>
          </div>

          <div className="absolute bottom-0 left-0 right-0 pointer-events-none">
            <p className="font-heading text-6xl md:text-8xl lg:text-9xl font-black text-white/6 leading-none tracking-tighter pl-6 md:pl-10 pb-4 md:pb-6 select-none whitespace-nowrap overflow-hidden">
              51黑料网 · {category.name}
            </p>
          </div>
        </section>

        {/* Featured Grid */}
        {gridArticles.length > 0 && (
          <section className="py-16 md:py-20" aria-labelledby="cat-grid-title">
            <div className="w-full px-6 md:px-10">
              <h2 id="cat-grid-title" className="text-3xl md:text-5xl font-black text-foreground-950 mb-10">
                {category.name}精选 🔥
              </h2>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
                {gridArticles.map((article) => (
                  <Link
                    key={article.id}
                    to={`/article/${article.id}`}
                    className="group cursor-pointer rounded-lg overflow-hidden relative h-[380px] md:h-[420px]"
                  >
                    <img
                      src={article.imageUrl}
                      alt={article.title}
                      className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                      loading="lazy"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/20 to-transparent"></div>
                    <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                      <span className="inline-block px-2 py-0.5 rounded-full bg-secondary-500/80 text-white text-xs font-medium mb-3 whitespace-nowrap">
                        {category.name}
                      </span>
                      <h3 className="text-base md:text-lg font-bold text-white leading-snug mb-2 line-clamp-2">
                        {article.title}
                      </h3>
                      <p className="text-sm text-white/50 line-clamp-2">{article.excerpt}</p>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </section>
        )}

        {/* All articles list */}
        <section className="bg-background-100 py-16 md:py-20" aria-labelledby="cat-all-title">
          <div className="w-full px-6 md:px-10">
            <h2 id="cat-all-title" className="text-2xl md:text-4xl font-black text-foreground-950 mb-10">
              全部{category.name}爆料
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {categoryArticles.map((article) => (
                <Link
                  key={article.id}
                  to={`/article/${article.id}`}
                  className="group cursor-pointer bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-accent-300/50 transition-all duration-300"
                >
                  <div className="relative h-48 overflow-hidden">
                    <img
                      src={article.imageUrl}
                      alt={article.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                      loading="lazy"
                    />
                  </div>
                  <div className="p-4 md:p-5">
                    <h3 className="text-sm md:text-base font-bold text-foreground-950 leading-snug mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
                      {article.title}
                    </h3>
                    <p className="text-xs text-foreground-500 line-clamp-2 mb-3">{article.excerpt}</p>
                    <div className="flex items-center gap-3 text-xs text-foreground-400">
                      <span>{article.date}</span>
                      <span className="flex items-center gap-1">
                        <i className="ri-eye-line"></i>
                        {article.views >= 10000 ? (article.views / 10000).toFixed(1) + '万' : article.views}
                      </span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}